module.exports = __webpack_public_path__ + "img/Ntabi_footer.5b7cd4fe.png";